import { api } from '../../lib/api';
import type { SearchResponse, SearchSort } from '@pms/shared';

export interface SearchParams {
  destination?: string | undefined;
  checkIn?: string | undefined;
  checkOut?: string | undefined;
  guests?: number | undefined;
  priceMin?: number | undefined;
  priceMax?: number | undefined;
  amenities?: string | undefined; // csv
  sort?: SearchSort | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

/** GET /v1/public/search — axios omits undefined params automatically. */
export async function searchStays(params: SearchParams): Promise<SearchResponse> {
  const { data } = await api.get<SearchResponse>('/search', { params });
  return data;
}
